import * as d3 from 'd3';

import {
  MAX_EARNINGS_FOR_SLIDER,
  MAX_STUDENT_POPULATION_FOR_SLIDER,
  MAX_NET_PRICE_FOR_SLIDER,
} from './Constants';

const percentFormater = d3.format('.0%');
const integerFormater = d3.format('.8');
const populationFormater = d3.format(',');
const dollarFormater = d3.format('$,');

const populationSliderFormater = value => {
  const thousands = value / 1000;

  if (value === 0) {
    return '0';
  }

  if (value >= MAX_STUDENT_POPULATION_FOR_SLIDER) {
    return `${thousands}k+`;
  }

  return `${thousands}k`;
};

const priceSliderFormater = value => {
  if (value === 0) {
    return '0';
  }

  if (value >= MAX_NET_PRICE_FOR_SLIDER) {
    return `$${MAX_NET_PRICE_FOR_SLIDER / 1000}k+`;
  }

  return `$${value / 1000}k`;
};

const earningsSliderFormater = value => {
  if (value === 0) {
    return '0';
  }

  if (value >= MAX_EARNINGS_FOR_SLIDER) {
    return `$${MAX_EARNINGS_FOR_SLIDER / 1000}k+`;
  }

  return `$${value / 1000}k`;
};

const numericToString = (numeric, formater, nanValue = 'Unknown') => {
  return numeric == null ? nanValue : formater(numeric);
};

const numericRangeToString = (numeric1, numeric2, formater, nanValue = 'Unknown') => {
  if (numeric1 === null || numeric2 === null) {
    return nanValue;
  }

  return `${formater(numeric1)} to ${formater(numeric2)}`;
};

export {
  percentFormater,
  integerFormater,
  populationFormater,
  dollarFormater,
  earningsSliderFormater,
  priceSliderFormater,
  numericToString,
  numericRangeToString,
  populationSliderFormater,
};



// WEBPACK FOOTER //
// ./src/App/Formatters.js